import backend from 'utils/backend';

// Pairs a client reader with the routes its cards link to, so the Loom sandbox is a different
// value for one prop rather than a second set of components. Only the read is swapped, plus the
// Family tab, which writes family members to Loom. Every other write, and every other service the
// detail page calls, stays on its legacy API. CQ-405 deletes the LOOM entry and its routes, and
// keeps the reader.
const CLIENT_SOURCES = {
  LEGACY: {
    api: () => backend.client,
    loadScheduleByMonth: (clientRn, byMonths, loadCaregiverUpdates, options) =>
      backend.client.schedule.loadByMonth(clientRn, byMonths, loadCaregiverUpdates, options),
    detailPath: '/client',
    familyTab: false,
  },
  LOOM: {
    api: () => backend.loom.client,
    loadScheduleByMonth: (clientRn, byMonths, loadCaregiverUpdates, options) =>
      backend.loom.schedule.loadClientMonths(clientRn, byMonths, loadCaregiverUpdates, options),
    detailPath: '/client/loom',
    familyTab: true,
  },
};

export default CLIENT_SOURCES;
